import Button from "components/UI/Button/Button";
import { Link } from "react-router-dom";

import { PERFORMERS_DATA } from "./performersData";
import { EVENTS, metricsEvent } from "metrics";

import "./PerformersSection.scss";

const PerformerCard = ({ name, age, occupation, image, review }) => (
  <div className="performers-section__card">
    <div className="performers-section__card-header">
      <img
        className="performers-section__card-header-img"
        src={image}
        alt={`Исполнитель биржи Boostclick ${name}`}
      />
      <div>
        <div className="performers-section__card-name">
          <p className="performers-section__card-name-text">{name}</p>
          <div className="performers-section__card-name-icon" />
        </div>
        <p className="performers-section__card-text">
          {age}, {occupation}
        </p>
      </div>
    </div>
    <div className="performers-section__card-review">{review}</div>
  </div>
);

const PerformersSection = ({ isMobile }) => {
  return (
    <section className="performers-section">
      <div className="performers-section__container">
        <div className="performers-section__about">
          <div className="performers-section__about-description">
            <h3 className="section__title">
              Кто такие исполнители на Boostclick?
            </h3>
            <p>
              Исполнители — это зарегистрированные пользователи платформы,
              которые выполняют задания клиентов в свободное время.
            </p>
            <p>
              Они используют свои устройства (телефоны и компьютеры), работают
              из разных городов и проходят сценарии так же, как при обычном
              поиске или выборе товара.
            </p>
          </div>
          {!isMobile && <Link to={process.env.REACT_APP_SUPPORT_ADDRESS} target="_blank"><Button className="performers-section__button-link" title="Стать исполнителем" onClick={() => { metricsEvent(EVENTS.TELEGRAM_HELP) }} /></Link>}
        </div>

        <div className="performers-section__grid">
          {PERFORMERS_DATA.map((performer) => (
            <PerformerCard key={performer.id} {...performer} />
          ))}
        </div>
        {isMobile && <Link to={process.env.REACT_APP_SUPPORT_ADDRESS} target="_blank"><Button className="performers-section__button-link" title="Стать исполнителем" onClick={() => { metricsEvent(EVENTS.TELEGRAM_HELP) }} /></Link>}

      </div>
    </section>
  );
};

export default PerformersSection;
